<mat-form-field *ngIf="descriptor">
    <mat-chip-list #chipList aria-label="selection">
        <mat-chip *ngFor="let item of formArray.controls; let i = index;" [selectable]="selectable"
            [removable]="removable" (removed)="remove(i)">
            {{item.value}}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip>
        <input [placeholder]="descriptor.controlLabel" [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="add($event)" />
    </mat-chip-list>
</mat-form-field>